import { C, ThresholdConfig, getSeverity } from '../../MapSharedData';
import { AggregatedRegion, RegionTooltip } from '../types';

interface Props {
  tooltip: RegionTooltip & { data: AggregatedRegion };
  cfg: ThresholdConfig;
}

export function RegionTooltipCard({ tooltip, cfg }: Props) {
  const sev = getSeverity(tooltip.data.total, cfg);

  return (
    <div
      className="fixed rounded-10 px-3.5 py-2.5 text-[13px] pointer-events-none z-[9999] shadow-popup min-w-[200px] max-w-[280px]"
      style={{ left: tooltip.x + 14, top: tooltip.y - 10, background: C.textPrimary, color: C.bg }}
    >
      <div className="font-semibold mb-1 text-sm">{tooltip.name}</div>
      <div className="mb-0.5" style={{ color: sev.color }}>
        {tooltip.data.total.toLocaleString()} incidents
      </div>
      <div className="text-[11px] mb-2" style={{ color: sev.color }}>
        {sev.label}
      </div>
      <div className="text-[11px] text-v2blueGray-500 italic mt-1">
        Click to zoom in & see postcodes
      </div>
    </div>
  );
}
